
import React, { useEffect, useState } from 'react'
import { ProgressBar } from 'react-loader-spinner';
import Header from 'units/dashboard/components/Header';
import { SidebarProvider } from 'units/dashboard/context/SidebarProvider';
import { useSelector } from 'react-redux';
import { toast } from "react-toastify";
import AdminSidebar from 'units/admin/components/AdminSidebar';
import Footer from 'units/dashboard/components/Footer';
import TransactionsTable from './components/TransactionsTable';
import {
    transaction,
    getFinancialLogs
} from "./services/transactionServices";
import FinancialLogsTable from "./components/FinancialLogsTable";

export default function TransactionsList() {
    const [loading, setLoading] = useState(false);
    const [transactionList, setTransactionList] = useState([])
    const [financialLogs, setFinancialLogs] = useState([]);
    const accessToken = useSelector((state) => state.auth.accessToken);

    const transactionsList = async () => {
        setLoading(true)
        try {
            const res = await transaction(accessToken)
            if (res?.ok) {
                setLoading(false)
                setTransactionList(res?.data)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }
    const financialLogsList = async () => {
        try {
            const res = await getFinancialLogs(accessToken);

            if (res?.ok) {
                setFinancialLogs(res?.data || []);
            }
        } catch (error) {
            console.log(error);
            toast.error(error?.message || "خطا در دریافت گزارش‌های مالی");
        }
    };
    useEffect(() => {
        transactionsList();
        financialLogsList();
    }, []);
    return (
        <>
            <SidebarProvider>
                <nav className="border-b border-slate-100 dark:bg-zinc-800 print:hidden flex items-center fixed top-0 right-0 left-0 bg-white z-10 dark:border-zinc-700">
                    <Header />
                </nav>

                <div className="vertical-menu rtl:right-0 fixed ltr:left-0 bottom-0 top-16 h-screen border-r bg-slate-50 border-gray-50 print:hidden dark:bg-zinc-800 dark:border-neutral-700 z-10">
                    <AdminSidebar />
                </div>
            </SidebarProvider>

            {loading ? (
                <div className="flex justify-center items-center h-screen">
                    <ProgressBar
                        visible={true}
                        height="80"
                        width="80"
                        color="#4fa94d"
                        ariaLabel="progress-bar-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                </div>
            ) : (
                <div className="flex flex-col min-h-screen mt-4">
                    <div className="main-content flex-grow pt-16 pb-5">
                        <div className="container-fluid px-[0.625rem] mt-3">
                            <div className="grid grid-cols-1 mb-2">
                                <div className="flex items-center justify-between">
                                    <h4 className="mb-sm-0 text-xl font-semibold grow text-gray-800 ">
                                        لیست پرداختی ها (تراکنش ها)
                                    </h4>
                                    <nav className="flex" aria-label="Breadcrumb"></nav>
                                </div>
                            </div>
                            <h1 className="text-md mr-2">

                                در این بخش شما می توانید تمامی پرداختی های انجام شده توسط مدیران کسب و کار را مشاهده کنید.
                            </h1>
                        </div>
                        <div className="mt-1 flex items-center justify-center p-2 col-span-12 xl:col-span-9 my-10">
                            <div className="w-full max-w-5xl rtl">

                                <TransactionsTable
                                    transactionList={transactionList}
                                    fetchTransactionsList={transactionsList}
                                />

                                <div className="mt-10">
                                    <FinancialLogsTable
                                        financialLogs={financialLogs}
                                    />
                                </div>

                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            )}
        </>
    )
}
